import BaseAPI from './BaseAPI';

export class SupportAPI extends BaseAPI {

	async getSupportTickets() {
		return this.request('/-/support/tickets', 'GET');
	}

}
